import axiosInstance from "./axiosInstance";

export interface AtraafDetail {
  ziyaratName: string;
  travelTimeMinutes: string;
  durationHours: string;
  transportType: string;
  optionalFlag: boolean;
}

export interface TourAtraaf {
  atraafId: number;
  publicId: string;
  atraafName: string;
  venueId: number;
  venueName: string;
  minDays: number;
  sortPriority: number;
  canBeDoneMultipleTimes: boolean;
  includeDaily: boolean;
  durationHours: string;
  transportRequired: boolean;
  optionalRoute: boolean;
  lawazimRequired: boolean;
  isActive: boolean;
  detailsCount: number;
  availableDays: number[];
  details: AtraafDetail[];
}

export interface TourAtraafResponse {
  success: boolean;
  message: string;
  data: TourAtraaf[];
  errors: string[];
}

export interface AvailablePropertyApi {
  propertyPublicId: string;
  propertyName: string;
}

export interface RoomTypeByPropertyApi {
  id: number;
  publicId: string;
  code: string;
  roomName: string;
  description: string;
  isActive: boolean;
}

export interface AvailableRoomApi {
  roomPublicId: string;
  roomNumber: string;
  isBooked: boolean;
}

export interface AvailableRoomsResponse {
  success: boolean;
  message: string;
  data: AvailableRoomApi[];
  errors: string[];
}

export interface CreateWalkInTourVenueSchedule {
  venueId: number;
  hotelPropertyId: number;
  hotelName: string;
  checkInDate: string;
  checkInTime: string;
  checkOutDate: string;
  checkOutTime: string;
}

export interface CreateWalkInTourRoomAvailability {
  venueId: number;
  checkInDate: string;
  checkOutDate: string;
  properties: {
    propertyId: number;
    rooms: {
      propertyRoomTypeId: number;
      requestedNumber: number;
    }[];
  }[];
}

export interface CreateWalkInTourPayload {
  parent_id: string;
  tourName: string;
  tourType: number;
  tourCategory: number;
  rotationId: number;
  tourOperatorId: number;
  noOfApplicants: number;
  faizAccommodation: boolean;
  accommodationPreference?: number;
  specialAccommodationRequest: string;
  notes: string;

  arrivalTransportMode: number;
  arrivalFlightNo: string;
  arrivalTime: string;
  arrivalPortId: number;
  arrivalDate: string;
  arrivalBookingRef: string;
  arrivalAirline: string;

  departureTransportMode: number;
  departureFlightNo: string;
  departureTime: string;
  departurePortId: number;
  departureDate: string;
  departureBookingRef: string;
  departureAirline: string;

  isArrivalConfirmed: boolean;
  isDepartureConfirmed: boolean;

  venueSchedules: CreateWalkInTourVenueSchedule[];

  roomAvailabilities?: CreateWalkInTourRoomAvailability[];

  createdBy: number;
  visaApplicantIds: number[];
}

export interface WalkInTourListVenueSchedule {
  tourVenueScheduleId: number;
  publicId: string;
  tourId: number;
  venueId: number;
  venueName: string;
  hotelPropertyId: number | null;
  hotelName: string;
  checkInDate: string;
  checkInTime: string;
  checkOutDate: string;
  checkOutTime: string;
}

export interface WalkInTourListItem {
  tourId: number;
  parent_id: number | null;
  publicId: string;
  tourCode: string;
  tourName: string;

  tourType: number;
  tourTypeName: string;

  tourCategory: number | null;

  rotationId: number | null;
  rotationName: string | null;

  tourOperatorId: number;
  tourOperatorName: string;
  officeName: string;

  noOfApplicants: number;

  faizAccommodation: boolean;
  accommodationPreference: number | null;
  specialAccommodationRequest: string | null;
  notes: string | null;

  isArrivalConfirmed: boolean;
  isDepartureConfirmed: boolean;

  status: number;
  isLocked: boolean;
  approvalStatus: number;
  statusName: string;
  action: string;
  isActive: boolean;

  arrivalDate: string;
  departureDate: string;

  venueCount: number;
  duration: number;
  durationDays: number;

  accommodationStatus: "R" | "Y" | "O" | "G";
  transportStatus: "R" | "Y" | "O" | "G";
  paxStatus: "R" | "Y" | "O" | "G";
  itineraryStatus: "R" | "Y" | "O" | "G";

  createdAt: string;

  venueSchedules: WalkInTourListVenueSchedule[];

  roomAvailabilities: unknown[];
}

export interface WalkInTourListResponse {
  items: WalkInTourListItem[];
  pageNo: number;
  pageSize: number;
  totalCount: number;
  pageNumber: number;
}

export interface WalkInTourShortlistedApplicant {
  publicId: string;
  shortlistedAt: string;
  shortlistedBy: number;
  visaApplicationId: number;

  tourOperatorId: number;
  toitsNumber: string;
  toFirstName: string;
  toMiddleName: string;
  toLastName: string;
  toFullName: string;
  toOfficeName: string;
  toOfficeNumber: string;
  toBusinessType: string;
  toArabicName: string;

  ejamaatId: string;
  itsNo: string;
  isNonItsUser: boolean;

  applicantType: string;
  category: string;

  guardianITS: string;
  hofITS: string;

  title: string;
  firstName: string;
  middleName: string;
  lastName: string;

  dateOfBirth: string;
  age: number;
  gender: string;
  birthPlace: string;
  nationality: string;
  profession: string;

  passportNo: string;
  passportType: string;
  passportFirstName: string;
  passportMiddleName: string;
  passportLastName: string;
  passportArabicName: string;
  passportDOB: string;
  passportGender: string;
  passportNationality: string;
  passportIssueDate: string;
  passportExpiryDate: string;
  passportIssuePlace: string;

  fatherName: string;
  fatherNameArabic: string;
  fatherITSNo: string;

  grandfatherName: string;
  grandfatherNameArabic: string;
  grandfatherITSNo: string;

  motherName: string;
  motherNameArabic: string;
  motherITSNo: string;

  mothersFatherName: string;
  mothersFatherNameArabic: string;
  mothersFatherITSNo: string;

  remarks: string;
  visaRequired: boolean;
  visaNotRequiredRemark: string;

  isMiqaatApplicant: boolean;

  rotationId: number | null;
  miqaatCode: string | null;
  miqaatName: string | null;
  rotationCode: string | null;
  rotationName: string | null;

  currentStatusCode: string;
  validationErrors: string;
  lastStatusMessage: string;

  certificateFilePath: string;
  certificateStatus: string;

  visaFee: number;
  currency: string | null;

  batchId: number;
  batchNumber: string;
  batchStatus: string | null;
  batchGuid: string;

  createdOn: string;

  documents: unknown[];
}

interface WalkInRoom {
  roomSelectionPublicId: string;
  propertyRoomTypeId: number;
  propertyRoomTypePublicId: string;
  roomTypeName: string;
  maxCapacity: number;
  requestedNumber: number;
}

interface WalkInProperty {
  propertyId: number;
  propertyPublicId: string;
  propertyName: string;
  rooms: WalkInRoom[];
}

interface WalkInRoomAvailability {
  venueId: number;
  venueName: string;
  properties: WalkInProperty[];
}

interface WalkInVenueSchedule {
  publicId: string;
  venueId: number;
  venueName: string;
  hotelPropertyId: number | null;
  hotelName: string;
  checkInDate: string;
  checkInTime: string;
  checkOutDate: string;
  checkOutTime: string;
}

export interface TourServiceApi {
  id: number;
  serviceId: number;
  serviceName: string;
  description: string;
  serviceType: string;
  isMandatory: boolean;
  isDefaultChecked: boolean;
  isActive: boolean;
  createdBy: number;
  createdOn: string;
}
 
export interface OptionalApplicantServiceApi {
  applicantId: number;
  services: TourServiceApi[];
}

export interface TourAvailabilityRecommendationApi {
  id: number;
  recommendPublicId: string;
  tourId: number;
  requestedStartDate: string;
  requestedEndDate: string;
  isAvailable: boolean;
  reason: string;
  acceptedAt: string | null;
  recommendedOn: string;
}

export interface RoomAllocationApplicantApi {
  tourRoomAllocationApplicantId: number;
  publicId: string;
  tourRoomAllocationId: number;
  visaApplicationId: number;
  itsNo: string;
  applicantName: string;
  isActive: boolean;
}

export interface RoomAllocationApi {
  tourRoomAllocationId: number;
  publicId: string;
  roomSelectionPublicId: string;
  venueName: string;
  propertyName: string;
  roomTypeName: string;
  minCapacity: number;
  maxCapacity: number;
  minAdults: number;
  maxAdults: number;
  maxChildren: number;
  roomAllocated: number;
  status: string;
  isActive: boolean;
  applicants: RoomAllocationApplicantApi[];
}

export interface WalkInTourDetailsResponse {
  tourId: number;
  parent_id: number | null;
  publicId: string;
  tourCode: string;
  tourName: string;

  tourType: number;
  tourCategory: number;
  rotationId: number | null;
  rotationName: string | null;

  tourOperatorId: number;
  tourOperatorName: string;

  noOfApplicants: number;

  faizAccommodation: boolean;
  accommodationPreference: number | null;
  specialAccommodationRequest: string | null;
  notes: string | null;

  arrivalTransportMode: number;
  arrivalFlightNo: string;
  arrivalTime: string;
  arrivalPortId: number;
  arrivalPortName: string;
  arrivalDate: string;
  arrivalBookingRef: string;
  arrivalAirline: string;

  departureTransportMode: number;
  departureFlightNo: string;
  departureTime: string;
  departurePortId: number;
  departurePortName: string;
  departureDate: string;
  departureBookingRef: string;
  departureAirline: string;

  isArrivalConfirmed: boolean;
  isDepartureConfirmed: boolean;

  status: number;
  isLocked: boolean;
  statusName: string;
  approvalStatus: number;
  isActive: boolean;

  createdBy: number;
  createdAt: string;

  venueSchedules: WalkInVenueSchedule[];
  roomAvailabilities: WalkInRoomAvailability[];
  roomAllocations: RoomAllocationApi[];
  tourAvailabilityRecommendations: TourAvailabilityRecommendationApi[];
  shortlistedApplicants: WalkInTourShortlistedApplicant[];
  mandatoryServices: TourServiceApi[];
  optionalServices: OptionalApplicantServiceApi[];
}

export interface CreateWalkInRoomAllocationPayload {
  tourPublicId: string;
  venueId: number;
  propertyPublicId: string;
  propertyRoomTypeId: number;
  roomNames: string[];
  capacity: number;
}

export interface CreateWalkInRoomAllocationRoom {
  id: number;
  publicId: string;
  roomRequestId: number;
  roomId: number;
  roomNumber: string;
  propertyId: number;
  propertyRoomTypeId: number;
  venueId: number;
  bookingDate: string;
}

export interface CreateWalkInRoomAllocationItem {
  tourRoomAllocationId: number;
  roomAllocationPublicId: string;
  roomNumber: string;
  capacity: number;
  createdAt: string;
  rooms: CreateWalkInRoomAllocationRoom[];
}

export interface CreateWalkInRoomAllocationResponse {
  success: boolean;
  message: string;
  data: {
    tourPublicId: string;
    venueId: number;
    venueName: string;
    propertyId: number;
    propertyName: string;
    propertyRoomTypeId: number;
    roomTypeName: string;
    roomNames: string[];
    capacity: number;
    allocations: CreateWalkInRoomAllocationItem[];
  };
  errors: string[];
}

export interface WalkInRoomAllocationListItem {
  roomAllocationPublicId: string;
  venueName: string;
  propertyName: string;
  roomType: string;
  roomNames: string[];
  capacity: number;
}

export interface WalkInRoomAllocationListResponse {
  success: boolean;
  message: string;
  data: WalkInRoomAllocationListItem[];
  errors: string[];
}

export interface UpdateWalkInRoomAllocationPayload {
  tourPublicId: string;
  roomName: string;
  capacity: number;
}

export interface UpdateWalkInRoomAllocationResponse {
  success: boolean;
  message: string;
  data: {
    roomAllocationPublicId: string;
    venueName: string;
    propertyName: string;
    roomType: string;
    roomNames: string[];
    capacity: number;
  };
  errors: string[];
}

export interface DeleteWalkInRoomAllocationResponse {
  success: boolean;
  message: string;
  data: boolean;
  errors: string[];
}


export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getAtraafFullDetails = async (): Promise<TourAtraafResponse> => {
  const res = await axiosInstance.get("/atraaf/full-details", {
    headers: getAuthHeader(),
  });

  return res.data;
};

export const getAvailableProperties = async (
  venuePublicId: string,
  startDate: string,
  endDate: string,
  propertyTypeId: string,
): Promise<AvailablePropertyApi[]> => {
  const res = await axiosInstance.get("/property/available-list", {
    headers: getAuthHeader(),
    params: {
      venuePublicId,
      startDate,
      endDate,
      propertyTypeId,
    },
  });

  return res.data.data;
};

export const getRoomTypesByProperty = async (
  propertyPublicId: string,
): Promise<RoomTypeByPropertyApi[]> => {
  const res = await axiosInstance.get(
    `/room-type/byProperty/${propertyPublicId}`,
    {
      headers: getAuthHeader(),
    },
  );

  return res.data;
};

export const getAvailableRooms = async (
  propertyPublicId: string,
  venuePublicId: string,
  startDate: string,
  endDate: string,
  roomTypePublicId: string,
): Promise<AvailableRoomApi[]> => {
  const res = await axiosInstance.get("/property/available-rooms", {
    headers: getAuthHeader(),
    params: {
      propertyPublicId,
      venuePublicId,
      startDate,
      endDate,
      roomTypePublicId,
    },
  });

  return res.data.data;
};

export const createWalkInTour = async (
  payload: CreateWalkInTourPayload,
): Promise<{ tourId: number; tourCode: string }> => {
  const res = await axiosInstance.post("/walkin-tours", payload, {
    headers: getAuthHeader(),
  });

  return res.data;
};

export const getWalkInTours = async (
  pageNo: number,
  pageSize: number,
): Promise<WalkInTourListResponse> => {
  const res = await axiosInstance.get("/walkin-tours/list", {
    headers: getAuthHeader(),
    params: {
      pageNo,
      pageSize,
    },
  });

  return res.data;
};

export const getWalkInTourByPublicId = async (
  publicId: string,
): Promise<WalkInTourDetailsResponse> => {
  const res = await axiosInstance.get(`/tours/${publicId}`, {
    headers: getAuthHeader(),
  });

  return res.data;
};

export const createWalkInRoomAllocation = async (
  payload: CreateWalkInRoomAllocationPayload,
): Promise<CreateWalkInRoomAllocationResponse> => {
  const res = await axiosInstance.post(
    "/tours/walkin-tours/room-allocation",
    payload,
    {
      headers: getAuthHeader(),
    },
  );

  return res.data;
};

export const getWalkInRoomAllocations = async (
  tourPublicId: string,
): Promise<WalkInRoomAllocationListResponse> => {
  const res = await axiosInstance.get("/tours/walkin-tours/room-allocation", {
    headers: getAuthHeader(),
    params: {
      tourPublicId,
    },
  });

  return res.data;
};

export const updateWalkInRoomAllocation = async (
  roomAllocationPublicId: string,
  payload: UpdateWalkInRoomAllocationPayload,
): Promise<UpdateWalkInRoomAllocationResponse> => {
  const res = await axiosInstance.put(
    `/tours/walkin-tours/room-allocation/${roomAllocationPublicId}`,
    payload,
    {
      headers: getAuthHeader(),
    },
  );

  return res.data;
};

export const deleteWalkInRoomAllocation = async (
  roomAllocationPublicId: string,
  tourPublicId: string,
): Promise<DeleteWalkInRoomAllocationResponse> => {
  const res = await axiosInstance.delete(
    `/tours/walkin-tours/room-allocation/${roomAllocationPublicId}`,
    {
      headers: getAuthHeader(),
      params: {
        tourPublicId,
      },
    },
  );

  return res.data;
};